// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__-mezt","container":"styles_container__1Sl6c","ellipsisIcon":"styles_ellipsisIcon__yaAor","menu":"styles_menu__iJ3t0","menuItem":"styles_menuItem__DZudN"};